module.exports = __webpack_public_path__ + "img/ConsumptionService.e7314f5e.png";